module.exports = __webpack_public_path__ + "img/kkb_hdmi_split.f218b264.jpg";